// Free sample add-to-cart flow
document.addEventListener("click", function (e) {
  // Support clicks on child elements inside the sample button (icons, spans, etc.)
  var sampleButton = e.target.closest
    ? e.target.closest(".sample-cart")
    : (e.target.classList && e.target.classList.contains("sample-cart") ? e.target : null);

  if (!sampleButton) return;

  // Avoid double-submits on slow devices
  if (sampleButton.disabled) return;

  e.preventDefault();

  var variantId = sampleButton.getAttribute("data-id");
  if (!variantId) {
    // If the button is misconfigured, do not lock it or interfere with normal add-to-cart.
    console.warn("Sample cart button missing data-id attribute.");
    return;
  }

  // Provide instant visual feedback while the request is in-flight.
  var originalText = sampleButton.textContent;
  var originalDisabled = sampleButton.disabled;
  sampleButton.disabled = true;
  sampleButton.classList.add("is-loading");
  sampleButton.textContent = "Adding…";

  // Mirror core product-form behavior so the cart drawer + header react normally.
  var sectionsToBundle = ["variant-added"];
  document.documentElement.dispatchEvent(
    new CustomEvent("cart:prepare-bundled-sections", {
      bubbles: true,
      detail: { sections: sectionsToBundle },
    })
  );

  var formData = new FormData();
  formData.set("id", variantId);
  formData.set("quantity", "1");
  formData.set("sections", sectionsToBundle.join(","));
  formData.set(
    "sections_url",
    Shopify.routes.root + "variants/" + encodeURIComponent(variantId)
  );

  fetch(Shopify.routes.root + "cart/add.js", {
    body: formData,
    method: "POST",
    headers: {
      "X-Requested-With": "XMLHttpRequest", // Needed for Shopify to check inventory
    },
  })
    .then(function (response) {
      return response.json().then(function (responseJson) {
        return { ok: response.ok, json: responseJson };
      });
    })
    .then(function (result) {
      var ok = result.ok;
      var responseJson = result.json;

      if (!ok) {
        throw new Error(
          responseJson && responseJson.description
            ? responseJson.description
            : "There was a problem adding the sample to your cart."
        );
      }

      // If the shop is using cart page instead of drawer, follow the core behavior.
      if (
        window.themeVariables.settings.cartType === "page" ||
        window.themeVariables.settings.pageType === "cart"
      ) {
        window.location.href = Shopify.routes.root + "cart";
        return;
      }

      // Fetch the full cart so the theme receives the complete cart object it expects.
      return fetch(Shopify.routes.root + "cart.js")
        .then(function (response) {
          return response.json();
        })
        .then(function (cartContent) {
          cartContent.sections = responseJson.sections || cartContent.sections;

          // Match the exact event order used by the core product-form:
          // 1) variant:add     2) cart:change
          document.documentElement.dispatchEvent(
            new CustomEvent("variant:add", {
              bubbles: true,
              detail: {
                items: responseJson.hasOwnProperty("items")
                  ? responseJson.items
                  : [responseJson],
                cart: cartContent,
              },
            })
          );

          document.documentElement.dispatchEvent(
            new CustomEvent("cart:change", {
              bubbles: true,
              detail: {
                baseEvent: "variant:add",
                cart: cartContent,
              },
            })
          );

          // Fast success feedback on the button once everything is synced.
          sampleButton.textContent = "Added";
          sampleButton.classList.remove("is-loading");
          setTimeout(function () {
            sampleButton.textContent = originalText;
            sampleButton.disabled = originalDisabled;
          }, 1500);
        });
    })
    .catch(function (error) {
      console.error("Error adding sample to cart:", error);
      // Uncomment this while testing on real devices to see Shopify's exact error:
      // alert(error.message);

      // Restore button state on error so it never feels stuck.
      sampleButton.textContent = originalText;
      sampleButton.disabled = originalDisabled;
      sampleButton.classList.remove("is-loading");

      document.dispatchEvent(
        new CustomEvent("cart:error", {
          bubbles: true,
          detail: {
            error: error.message,
          },
        })
      );
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    });
});

// Ensure scroll unlock when coming back from external flows (e.g. Recharge) via browser "Back" using BF cache.
window.addEventListener("pageshow", function (event) {
  if (event.persisted) {
    document.documentElement.classList.remove("lock");
  }
});

// Price change as per Subscriptions
document.addEventListener("DOMContentLoaded", (event) => {

  if (location.href.includes("/products/")) {
  try {
    var productJson = document.getElementById("product-json");
    if (!productJson) throw new Error("Product JSON element not found!");

    var productData = JSON.parse(productJson.textContent);
    if (!productData || !productData.selling_plan_groups) throw new Error("Invalid product JSON data!");

    document.addEventListener("variant:change", function(event) {
      try {
        if (!event.detail || !event.detail.variant) throw new Error("Variant change event data missing!");
        window.currentVariant = event.detail.variant;
        window.UpdateRcPriceBasedOnRechargeWidget();
      } catch (error) {
        console.error("Error in variant:change event listener:", error);
      }
    });

    window.UpdateRcPriceBasedOnRechargeWidget = function() {
      setTimeout(function() {
        try {
          let sellingPlanId = new URL(location.href).searchParams.get('selling_plan');
          if (!sellingPlanId) throw new Error("Selling plan ID not found in URL!");

          let loopBreak = false;

          for (let spg in productData.selling_plan_groups) {
            for (let spg_sp in productData.selling_plan_groups[spg].selling_plans) {
              let planId = productData.selling_plan_groups[spg].selling_plans[spg_sp].id;
              if (planId == sellingPlanId) {
                let adjustment = productData.selling_plan_groups[spg].selling_plans[spg_sp].price_adjustments[0];
                if (!adjustment || adjustment.value_type !== "percentage") continue;

                let discountPercentage = adjustment.value;
                if (typeof window.currentVariant?.price !== "number") throw new Error("Invalid currentVariant price!");

                let valueAfterPercentageDiscount = window.currentVariant.price - (window.currentVariant.price * (discountPercentage / 100));
                let formattedMoney = (valueAfterPercentageDiscount / 100).toLocaleString(
                  Shopify.locale + "-" + Shopify.country, 
                  { style: 'currency', currency: Shopify.currency.active }
                );

                console.log("Updated After 100 ms!");
                let priceElement = document.querySelector(".product-info__price price-list sale-price");
                if (!priceElement) throw new Error("Price element not found in DOM!");

                priceElement.innerHTML = `<span class="sr-only">Sale price</span> ${formattedMoney}`;
                loopBreak = true;
                break;
              }
            }
            if (loopBreak) break;
          }
        } catch (error) {
          console.error("Error in UpdateRcPriceBasedOnRechargeWidget:", error);
        }
      }, 100);
    };

    function checkElement_rcOnPDP() {
      try {
        let rcSelect = document.querySelector(".rc-widget .rc-selling-plans-dropdown__select");
        let rcCheckbox = document.querySelector(".rc-widget #rc-checkbox1");

        if (rcSelect) {
          clearInterval(intervalId_rcOnPDP);
          rcSelect.addEventListener("change", function() {
            try {
              window.UpdateRcPriceBasedOnRechargeWidget();
            } catch (error) {
              console.error("Error in rc-selling-plans-dropdown change event:", error);
            }
          });
          window.UpdateRcPriceBasedOnRechargeWidget();
        }

        if (rcCheckbox) {
          rcCheckbox.addEventListener("change", function(e) {
            try {
              if (e.currentTarget.checked) {
                rcSelect.addEventListener("change", function() {
                  try {
                    window.UpdateRcPriceBasedOnRechargeWidget();
                  } catch (error) {
                    console.error("Error in rc-selling-plans-dropdown change event:", error);
                  }
                });
                window.UpdateRcPriceBasedOnRechargeWidget();
              } else {
                if (typeof window.currentVariant?.price !== "number") throw new Error("Invalid currentVariant price!");
                let formattedMoney = (window.currentVariant.price / 100).toLocaleString(
                  Shopify.locale + "-" + Shopify.country, 
                  { style: 'currency', currency: Shopify.currency.active }
                );

                let priceElement = document.querySelector(".product-info__price price-list sale-price");
                if (!priceElement) throw new Error("Price element not found in DOM!");

                priceElement.innerHTML = `<span class="sr-only">Sale price</span> ${formattedMoney}`;
              }
            } catch (error) {
              console.error("Error in rc-checkbox change event:", error);
            }
          });
        }
      } catch (error) {
        console.error("Error in checkElement_rcOnPDP:", error);
      }
    }

    let attempts_rcOnPDP = 0;
    const intervalId_rcOnPDP = setInterval(() => {
      if (attempts_rcOnPDP++ > 30) {
        clearInterval(intervalId_rcOnPDP);
        return;
      }
      checkElement_rcOnPDP();
    }, 1000);

  } catch (error) {
    console.error("Error in product page script:", error);
  }
}


  
});

